(function(){
'use strict';
document.querySelectorAll('.oaf-price-breakdown').forEach(function(breakdown){
var base=Number(breakdown.dataset.oafBaseCents);
var currency=breakdown.dataset.oafCurrency||'USD';
var output=breakdown.querySelector('.oaf-price-options');
var price=breakdown.querySelector('[id^="price-"]');
if(!price||!Number.isFinite(base))return;
var formatter=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency});
function update(){
var sale=price.querySelector('.price--on-sale .price-item--sale');
var regular=price.querySelector('.price__regular .price-item--regular');
var amount=sale||regular;
if(!amount)return;
var numeric=amount.textContent.replace(/[^0-9.\-]/g,'');
var total=Math.round(Number(numeric)*100);
if(!Number.isFinite(total))return;
var difference=total-base;
var text=(difference>0?'+':'')+formatter.format(difference/100);
if(output.textContent!==text)output.textContent=text;
}
new MutationObserver(update).observe(price,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['class']});
update();
});
})();